import * as Yup from "yup";
import { getInitialValues } from "layouts/views/common/common";

const formField = {
  asnNumber: {
    type: "text",
    name: "asnNumber",
    label: "ASN Number",
    errorMsg: "ASN Number is required",
    maxLength: 20,
    disabled: true,
  },
  dateExpected: {
    type: "datetime",
    name: "dateExpected",
    label: "Arrival Date",
  },
  vendorCode: {
    type: "select",
    name: "vendorCode",
    label: "Vendor Code",
    errorMsg: "Vendor Code is required",
    required: true,
    maxLength: 20,
    editable: false,
  },
  customerCode: {
    type: "text",
    name: "customerCode",
    label: "Customer Code",
    errorMsg: "Customer Code is required",
    required: true,
    maxLength: 20,
    disabled: true,
  },
  poNumber: {
    type: "select",
    name: "poNumber",
    label: "PO Number",
    errorMsg: "PO Number is required",
    required: true,
    maxLength: 20,
    editable: false,
  },
  carrierRef: {
    type: "text",
    name: "carrierRef",
    label: "Carrier Reference",
    maxLength: 20,
  },
  truckNo: {
    type: "text",
    name: "truckNo",
    label: "Truck No",
    maxLength: 20,
  },
  containerNo: {
    type: "text",
    name: "containerNo",
    label: "Container No",
    maxLength: 20,
    size:3
  },
  containerType: {
    type: "select",
    name: "containerType",
    label: "Container Type",
    size:3
  },
  sellerCompany: {
    type: "text",
    name: "sellerCompany",
    label: "Company",
    maxLength: 100,
  },
  sellerAddress1: {
    type: "text",
    name: "sellerAddress1",
    label: "Address 1",
    maxLength: 200,
  },
  sellerAddress2: {
    type: "text",
    name: "sellerAddress2",
    label: "Address 2",
    maxLength: 200,
  },
  sellerPostcode: {
    type: "text",
    name: "sellerPostcode",
    label: "Postcode",
    maxLength: 10,
  },
  sellerCity: {
    type: "text",
    name: "sellerCity",
    label: "City",
    maxLength: 100,
  },
  sellerState: {
    type: "text",
    name: "sellerState",
    label: "State",
    maxLength: 100,
  },
  sellerCountry: {
    type: "select",
    name: "sellerCountry",
    label: "Country",
    maxLength: 100,
  },
  sellerPhoneNo: {
    type: "text",
    name: "sellerPhoneNo",
    label: "Tel No",
    maxLength: 20,
  },
  sellerFaxNo: {
    type: "text",
    name: "sellerFaxNo",
    label: "Fax No",
    maxLength: 20,
    size:3
  },
  status: {
    type: "text",
    name: "status",
    label: "Status",
    disabled: true,
  },
  remark: {
    type: "text",
    name: "remark",
    label: "Remark",
    maxLength: 300,
    size:3
  },
};

const {
  asnNumber,
  dateExpected,
  vendorCode,
  customerCode,
  poNumber,
  carrierRef,
  truckNo,
  containerNo,
  containerType,
  sellerCompany,
  sellerAddress1,
  sellerAddress2,
  sellerPostcode,
  sellerCity,
  sellerState,
  sellerCountry,
  sellerPhoneNo,
  sellerFaxNo,
  status,
  remark,
} = formField;

export const headerRender = [
  [asnNumber, vendorCode, customerCode, status],
  [poNumber, dateExpected, carrierRef, truckNo],
  [containerNo, containerType,remark],
  [
    {
      type: "fieldset",
      label: "Vendor",
      fieldsetRender: [
        [sellerCompany  ],
        [sellerAddress1, sellerAddress2, sellerPostcode,sellerCity  ],
        [sellerState, sellerCountry, sellerPhoneNo,sellerFaxNo],
      ],
    },
  ],
];

export const headerValues = getInitialValues(formField);

export const headerValidation = Yup.object().shape({
  [asnNumber.name]: Yup.string().nullable(),
  [dateExpected.name]: Yup.string().nullable(),
  [vendorCode.name]: Yup.string()
    .nullable()
    .max(vendorCode.maxLength)
    .required(vendorCode.errorMsg),
  [customerCode.name]: Yup.string()
    .nullable()
    .max(customerCode.maxLength)
    .required(customerCode.errorMsg),
  [poNumber.name]: Yup.string().nullable().max(poNumber.maxLength).required(poNumber.errorMsg),
  [carrierRef.name]: Yup.string().nullable().max(carrierRef.maxLength),
  [truckNo.name]: Yup.string().nullable().max(truckNo.maxLength),
  [containerNo.name]: Yup.string().nullable().max(containerNo.maxLength),
  [containerType.name]: Yup.string().nullable().max(containerType.maxLength),
  [sellerCompany.name]: Yup.string().nullable().max(sellerCompany.maxLength),
  [sellerAddress1.name]: Yup.string().nullable().max(sellerAddress1.maxLength),
  [sellerAddress2.name]: Yup.string().nullable().max(sellerAddress2.maxLength),
  [sellerPostcode.name]: Yup.string().nullable().max(sellerPostcode.maxLength),
  [sellerCity.name]: Yup.string().nullable().max(sellerCity.maxLength),
  [sellerState.name]: Yup.string().nullable().max(sellerState.maxLength),
  [sellerCountry.name]: Yup.string().nullable().max(sellerCountry.maxLength),
  [sellerPhoneNo.name]: Yup.string().nullable().max(sellerPhoneNo.maxLength),
  [sellerFaxNo.name]: Yup.string().nullable().max(sellerFaxNo.maxLength),
  [status.name]: Yup.string().nullable(),
  [remark.name]: Yup.string().nullable().max(remark.maxLength),
});
